<template>
    <div>
		<div :class="{'collapsemenu':collapsemenu===true,[this.lineaClass]: true}" id="body-row">
			<Sidebar></Sidebar>
			<div id="panel-principal">
				<navbar></navbar>
				<slot />
				<Footer></Footer>
			</div>
		</div>
    </div>
</template>
<script>
import navbar from '@/components/layout/Navbar'
import Sidebar from '@/components/layout/Sidebar2'
import Footer from '@/components/layout/Footer'
import { mapState } from 'vuex'
export default {
	name: 'Content',
	components: {
		navbar,
		Sidebar,
		Footer
	},
	mounted () {
		const plugin = document.createElement('script')
		plugin.setAttribute(
			'src',
			'https://kit.fontawesome.com/c1b864fb23.js'
		)
		document.head.appendChild(plugin)
	},
	computed: {
		...mapState(['collapsemenu', 'lineaNegocio']),
		lineaClass () {
			let result = ''
			if (this.lineaNegocio) {
				result = 'app-linea-negocio-' + this.lineaNegocio.code
			}
			return result
		}
	}
}

</script>



// WEBPACK FOOTER //
// src/components/Content.vue